module.exports = __webpack_public_path__ + "img/qt-xxtx.1d602d33.svg";